import camelcaseKeys from 'camelcase-keys';

import { updateRefreshTokenAtom } from '../store/Atoms';
import { writeAtom } from '../store/JotaiCallbacks';

export type CustomError = Error & {
    response?: Response;
    status?: number;
    reason?: string;
};

async function checkStatus(response: Response) {
    if (response.status >= 200 && response.status < 300) {
        // If response is successful, check if it's JSON
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            // If response is JSON, parse and return it
            return response.json();
        } else {
            // If response is not JSON, return the status code
            return response.status;
        }
    }

    // Errors are all in the form of JSON
    const jsonResponse = await response.json();
    if (response.status === 401) {
        if (jsonResponse.code === 'token_not_valid') {
            await writeAtom(updateRefreshTokenAtom);
        }
    }

    const error: CustomError = new Error(response.statusText);
    error.response = jsonResponse;
    error.status = response.status;
    error.reason = jsonResponse?.detail || '';
    throw error;
}

function parseData(data: any) {
    return typeof data === 'object'
        ? camelcaseKeys(data, {
              deep: true,
              exclude: [/^([0-9A-Fa-f]{2}){6}$|^([0-9A-Fa-f]{4}){4}$/], // Exclude MAC addresses as keys
          })
        : data;
}

export function customFetch(
    url: RequestInfo | URL,
    init: RequestInit = {}
): Promise<Response> {
    return fetch(url, {
        ...init,
        credentials: 'include',
        headers: {
            ...(init.headers || {}),
            'Content-Type': 'application/json',
        },
    });
}

export default function fetchWrapper(
    url: RequestInfo | URL,
    init: RequestInit = {}
) {
    return customFetch(url, init).then(checkStatus).then(parseData);
}
